import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to top whenever the route pathname changes.
 * Fixes the common SPA UX bug where new pages open at the previous
 * scroll position (bottom) instead of the top.
 * Hash navigation (/path#section) is preserved.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // allow anchor jumps
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
